<template>
  <div
    class="m-subjects"
    data-cy="subjects"
  >
    <UnderlinedTitle
      tag="h2"
      tag-class="h5"
      :title="$t('subjects.title')"
    />
    <ul>
      <li
        v-for="subject in subjects"
        :key="subject.slug"
      >
        <span
          v-html="subject.name"
        />
        <template v-if="subject.children.length">
          >
          <span
            class="sub-subject"
            v-for="subsubject in subject.children"
            :key="subsubject.slug"
            v-html="subsubject.name"
          />
        </template>
      </li>
    </ul>
  </div>
</template>
<script>
import UnderlinedTitle from '@components/UnderlinedTitle'

export default {
  name: 'Subjects',
  components: {
    UnderlinedTitle
  },
  props: {
    subjects: {
      type: Array,
      required: true
    }
  },
  methods: {
    getLabel (parent) {
      return `${parent.name}${parent.children.length > 0 ? ` > ${parent.children.map(item => item.name).join(', ')}` : ''}`
    }
  }
}
</script>
<style lang="less">
@import (reference) "~@less/shared/utilities.less";

.m-subjects {
   ul {
    .small-box-vertical-margin;

    li {
      font-family: @font-sans-serif;
      margin: .3rem 0;
    }

    .sub-subject:not(:last-child) {
      &::after {
        content: ', '
      }
    }

    .border-hr {
      background: @nfb-violet;
    }
  }
}
</style>
